export default "__VITE_ASSET__D1m_2kLa__"